'use client';

import { useEffect, useState } from 'react';

import { ChatTextarea } from '@/app/_components/chat-content/ChatTextarea';
import { ScrollButton } from '@/app/_components/chat-content/ScrollButton';

export const StickyChat = ({
  viewMode,
  isAlwaysVisible = true,
  scrollButtonDirection
}: {
  viewMode: 'sticky' | 'fixed' | 'hidden';
  isAlwaysVisible?: boolean;
  scrollButtonDirection?: 'top' | 'bottom';
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // 검증자 UI가 화면 하단으로부터 106px 지점에 도달했을 때 StickyChat 노출
  useEffect(() => {
    if (viewMode === 'hidden') {
      setIsVisible(false);
      return;
    }

    // isAlwaysVisible이 true면 항상 표시
    if (isAlwaysVisible) {
      setIsVisible(true);
      return;
    }

    const checkVerifierPosition = () => {
      const verifierElement = document.querySelector('[role="contentinfo"]');

      if (!verifierElement) {
        setIsVisible(false);
        return;
      }

      const rect = verifierElement.getBoundingClientRect();
      const threshold = window.innerHeight - 106;

      if (rect.bottom <= threshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // 초기 체크
    checkVerifierPosition();

    window.addEventListener('scroll', checkVerifierPosition, { passive: true });
    window.addEventListener('resize', checkVerifierPosition, { passive: true });

    return () => {
      window.removeEventListener('scroll', checkVerifierPosition);
      window.removeEventListener('resize', checkVerifierPosition);
    };
  }, [viewMode, isAlwaysVisible]);

  if (viewMode === 'hidden') {
    return null;
  }

  return (
    <>
      {scrollButtonDirection && <ScrollButton direction={scrollButtonDirection} footerVisible={isVisible} />}

      <footer
        className={`${viewMode} left-0 bottom-0 z-50 flex w-[100%] items-center rounded-t-[40px] shadow-[0px_-2px_0px_0px_var(--neutral-border-main,rgba(0,30,57,0.06)),0px_0px_0px_8px_#FFF] min-w-80 bg-white pt-3 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full pointer-events-none'
        }`}
        style={{
          transition: 'all 300ms cubic-bezier(0.2, 0, 0, 1)'
        }}
      >
        <div className={'container container-large px-normal-small'}>
          <ChatTextarea location={'bottom'} />
        </div>
      </footer>
    </>
  );
};
